import * as s from "react";
import { j as w } from "./jsx-runtime-3tyXYecC.mjs";
import { u as M } from "./useForkRef-C_4o__cU.mjs";
import { o as H, d as N } from "./ownerWindow-CJokPycY.mjs";
import { u as z } from "./useEnhancedEffect-CJGo-L3B.mjs";
function f(o) {
  return parseInt(o, 10) || 0;
}
const B = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function j(o) {
  return o == null || Object.keys(o).length === 0 || o.outerHeightStyle === 0 && !o.overflowing;
}
const $ = /* @__PURE__ */ s.forwardRef(function(l, C) {
  const {
    onChange: x,
    maxRows: g,
    minRows: c = 1,
    style: y,
    value: v,
    ...T
  } = l, {
    current: E
  } = s.useRef(v != null), u = s.useRef(null), W = M(C, u), R = s.useRef(null), b = s.useRef(null), m = s.useCallback(() => {
    const t = u.current, e = H(t).getComputedStyle(t);
    if (e.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const n = b.current;
    n.style.width = e.width, n.value = t.value || l.placeholder || "x", n.value.slice(-1) === `
` && (n.value += " ");
    const h = e.boxSizing, a = f(e.paddingBottom) + f(e.paddingTop), k = f(e.borderBottomWidth) + f(e.borderTopWidth), S = n.scrollHeight;
    n.value = "x";
    const p = n.scrollHeight;
    let r = S;
    c && (r = Math.max(Number(c) * p, r)), g && (r = Math.min(Number(g) * p, r)), r = Math.max(r, p);
    const A = r + (h === "border-box" ? a + k : 0), F = Math.abs(r - S) <= 1;
    return {
      outerHeightStyle: A,
      overflowing: F
    };
  }, [g, c, l.placeholder]), d = s.useCallback(() => {
    const t = m();
    if (j(t))
      return;
    const i = t.outerHeightStyle, e = u.current;
    R.current !== i && (R.current = i, e.style.height = `${i}px`), e.style.overflow = t.overflowing ? "hidden" : "";
  }, [m]);
  z(() => {
    const t = () => {
      d();
    };
    let i;
    const e = N(t), n = u.current, h = H(n);
    h.addEventListener("resize", e);
    let a;
    return typeof ResizeObserver < "u" && (a = new ResizeObserver(t), a.observe(n)), () => {
      e.clear(), cancelAnimationFrame(i), h.removeEventListener("resize", e), a && a.disconnect();
    };
  }, [m, d]), z(() => {
    d();
  });
  const O = (t) => {
    E || d(), x && x(t);
  };
  return /* @__PURE__ */ w.jsxs(s.Fragment, {
    children: [/* @__PURE__ */ w.jsx("textarea", {
      value: v,
      onChange: O,
      ref: W,
      rows: c,
      style: y,
      ...T
    }), /* @__PURE__ */ w.jsx("textarea", {
      "aria-hidden": !0,
      className: l.className,
      readOnly: !0,
      ref: b,
      tabIndex: -1,
      style: {
        ...B.shadow,
        ...y,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
export {
  $ as T
};
//# sourceMappingURL=TextareaAutosize-CWylSdQ8.mjs.map
